document.addEventListener("DOMContentLoaded", function () {
	/* Search */
	const search = document.querySelector(".search-icon");
	const searchMenu = document.querySelector(".search-menu");
    const searchClose = document.querySelector(".search-menu .close-icon");

	search.addEventListener("click", () => {
		searchMenu.classList.toggle("active");
	});

    searchClose.addEventListener("click", () => {
        searchMenu.classList.remove("active");
    })

    /* Burger */
	const burger = document.querySelector(".burger-icon");
	const burgerMenu = document.querySelector(".site-header .wrapper");
	const header = document.querySelector(".site-header");

	burger.addEventListener("click", () => {
		burgerMenu.classList.toggle("active");
		header.classList.toggle("solid");
	});

	/* Scroll checker */
	var scrollEventChecker = function (obj) {
		var elmt = obj.elmt != undefined ? obj.elmt : [];
		var gap = obj.gap != undefined ? obj.gap : 100;
		var bind = obj.bind != undefined ? obj.bind : function () {};
		jQuery(window).on("scroll", checkOffset);
		jQuery(window).on("resize", checkOffset);
		jQuery(document).ready(function () {
			checkOffset();
		});
		function checkOffset() {
			var elmts = jQuery("[" + elmt + "]");
			elmts.each(function () {
				jQuery(this).css("transition-delay", jQuery(this).attr(elmt) + "s");
			});
			var scroll = jQuery(window).scrollTop();
			for (var i = 0; i < elmts.length; i++) {
				if (jQuery(elmts[i]).offset().top - scroll <= jQuery(window).height() - gap) {
					bind(elmts[i]);
				}
			}
		}
	};

	jQuery('.related ul').append("<div class='back pb-btn pb-btn--ghost'>Retour à la boutique</div>");
	jQuery('#customer_login .woocommerce-form').before("<h1 class='pb-page-title'><span class='fade-in' data-animate='.3' style='display: block'>Connexion</span></h1>")
	jQuery('.woocommerce-ResetPassword').before("<h1 class='pb-page-title'><span class='fade-in' data-animate='.3' style='display: block'>Mot de passe oublié ?</span></h1>")
	jQuery('.woocommerce-form-login__submit').html('Se connecter')
	jQuery('.woocommerce-form-login__submit, .woocommerce-Button').addClass('pb-btn')
	jQuery('.coupon .button').addClass('pb-btn--ghost')

    // Init Scroll checker instance
	var animateItem = new scrollEventChecker({
		elmt: "data-animate",
		gap: 0,
		bind: (elmt) => jQuery(elmt).addClass("visible"),
	});
});
